import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthFetchPatch } from "@/utils/authFetchPatch";

// Install the auth fetch patch BEFORE App mounts so every initial fetch
// (e.g. ProtectedRoute's /auth/me) carries the localStorage token if present.
installAuthFetchPatch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
